import { Injectable } from '@angular/core';
import { Resolve, Router} from '@angular/router';
import { MetaService } from '@ngx-meta/core';
import { StorageService } from '../_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../_services/api.service';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CarrelloService } from '../_services/carrello.service';

@Injectable()
export class CarrelloResolver implements Resolve<any> {

  constructor(
    private translate: TranslateService,
    private router: Router,
    private storage: StorageService,
    private carrelloService: CarrelloService,
    private meta: MetaService
    ) {
  }

  resolve() {
    this.meta.setTag('robots', 'noindex');
    return this.carrelloService.getCarrello();
  }

}
